module.exports = __webpack_public_path__ + "static/img/dynamich.a09d7f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamich.png
// module id = bb9r
// module chunks = 45